module.exports = __webpack_public_path__ + "static/media/20200731-152430-004.31c8da73.png";